import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { FACULTY_ADDER_ACTIONS } from "@/admin/hooks/useFacultyAdderReducer";
import AdminConsoleFacultyAdderTeacherSection from "../AdminConsoleFacultyAdderTeacherSection";
import {
  optionalDisclaimerCss,
  checkboxCustomCss,
} from "./AdminConsoleFacultyAdderDistrictAdminSection.style";

const propTypes = {
  // Component form values.
  formValues: PropTypes.shape({
    lowestGrade: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.number,
          description: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    highestGrade: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.number,
          description: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    sisId: PropTypes.string,
    school: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          uniqueId: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    isTeacher: PropTypes.bool,
    subjects: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        checked: PropTypes.bool,
      }),
    ),
  }),
  // Parent reducer dispatcher.
  dispatchAction: PropTypes.func,
};

const DISTRICT_ADMIN_SECTION_DISCLAIMER =
  "Each role has access to unique functionality on Newsela. To access another role’s functionality, select it from the list below.";

const AdminConsoleFacultyAdderDistrictAdminSection = ({
  formValues,
  dispatchAction,
}) => {
  return (
    <>
      <p css={optionalDisclaimerCss}>
        {DISTRICT_ADMIN_SECTION_DISCLAIMER} <span>(optional)</span>
      </p>
      <Checkbox
        __cssFor={checkboxCustomCss}
        label="Teacher"
        name="isTeacher"
        value="isTeacher"
        checked={formValues.isTeacher}
        onClick={() => {
          dispatchAction({
            type: FACULTY_ADDER_ACTIONS.SET_ROLE_SECTION,
            payload: {
              ...formValues,
              isTeacher: !formValues.isTeacher,
            },
          });
        }}
      />
      {!!formValues.isTeacher && (
        <AdminConsoleFacultyAdderTeacherSection
          formValues={formValues}
          dispatchAction={dispatchAction}
        />
      )}
    </>
  );
};

AdminConsoleFacultyAdderDistrictAdminSection.propTypes = propTypes;

export default AdminConsoleFacultyAdderDistrictAdminSection;

export { DISTRICT_ADMIN_SECTION_DISCLAIMER };
